import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface OpportunitiesSliceState {
    isSyncingData: boolean
    showSyncModal: boolean
}

export const initialState: OpportunitiesSliceState = {
    isSyncingData: false, 
    showSyncModal: false
}


const opportunitiesSlice = createSlice({
    name: 'opportunities',
    initialState,
    reducers: {
        setIsSyncingData(state, { payload }: PayloadAction<boolean>) {
            state.isSyncingData = payload
        }, 
        setShowSyncModal(state, { payload }: PayloadAction<boolean>) {
            state.showSyncModal = payload
        } 
    }
})

export const {
    setIsSyncingData,
    setShowSyncModal,
} = opportunitiesSlice.actions


export default opportunitiesSlice.reducer